import { render, staticRenderFns } from "./DsaPoster.vue?vue&type=template&id=731de928&scoped=true"
import script from "./DsaPoster.vue?vue&type=script&lang=js"
export * from "./DsaPoster.vue?vue&type=script&lang=js"
import style0 from "./DsaPoster.vue?vue&type=style&index=0&id=731de928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731de928",
  null
  
)

export default component.exports